@if (vista; as v) {
  <section class="grilla">
    <app-dt-card titulo="Equipo" icono="videocam" class="tarjeta">
      <app-dt-datos>
        <app-dt-dato etiqueta="Tipo" [valor]="v.tipo" />
        <app-dt-dato etiqueta="Marca y modelo" [valor]="v.marcaModelo" />
        <app-dt-dato
          etiqueta="Número de serie"
          [valor]="v.numeroSerie"
          mono
          copiable
        />
        <app-dt-dato etiqueta="Fecha de creación" [valor]="v.fechaCreacion" />
      </app-dt-datos>
    </app-dt-card>

    <!-- La contraseña y las claves P2P no se muestran -->
    <app-dt-card titulo="Conexión" icono="cell_tower" class="tarjeta">
      <app-dt-datos>
        @if (v.esP2P) {
          <app-dt-dato etiqueta="Conexión" valor="P2P, por número de serie" />
        } @else {
          <app-dt-dato etiqueta="Host" [valor]="v.host" mono copiable />
          <app-dt-dato etiqueta="Puerto HTTP" [valor]="v.puertoHTTP" mono />
          <app-dt-dato etiqueta="Puerto RTSP" [valor]="v.puertoRTSP" mono />
        }
        <app-dt-dato etiqueta="Usuario" [valor]="v.usuario" mono />
      </app-dt-datos>
    </app-dt-card>

    <app-dt-card
      [titulo]="'Canales (' + v.canales.length + ')'"
      icono="view_module"
      class="tarjeta ancha"
    >
      @if (v.canales.length) {
        <div class="canales">
          @for (c of v.canales; track $index) {
            <!-- Alto fijo: cada línea se corta con "…" y el texto completo
                 queda en el title -->
            <div class="canal">
              <strong class="linea" [attr.title]="c.titulo">
                {{ c.titulo }}
              </strong>
              @if (c.detalle) {
                <span class="dt-muted linea" [attr.title]="c.detalle">
                  {{ c.detalle }}
                </span>
              }
              @if (c.descripcion) {
                <span class="dt-muted linea" [attr.title]="c.descripcion">
                  {{ c.descripcion }}
                </span>
              }
              @if (c.modelo) {
                <span class="dt-muted linea" [attr.title]="c.modelo">
                  {{ c.modelo }}
                </span>
              }
            </div>
          }
        </div>
      } @else {
        <span class="dt-muted">No tiene canales cargados</span>
      }
    </app-dt-card>

    @if (verAlarmas) {
      <app-dt-card
        titulo="Alarmas asociadas"
        icono="doorbell"
        class="tarjeta ancha"
      >
        @if (alarmas === null) {
          <span class="dt-muted">Buscando…</span>
        } @else if (alarmas.length) {
          <div class="alarmas">
            @for (a of alarmas; track a.ruta[4]) {
              <a class="irx-enlace alarma" [routerLink]="a.ruta">
                <mat-icon>doorbell</mat-icon>
                {{ a.nombre }}
                @if (a.abonado) {
                  <span class="dt-muted dt-mono">{{ a.abonado }}</span>
                }
              </a>
            }
          </div>
        } @else {
          <span class="dt-muted">No está asociada a ninguna alarma</span>
        }
      </app-dt-card>
    }
  </section>
} @else {
  <app-empty-state
    icon="videocam_off"
    message="No se encontraron datos de la cámara"
  ></app-empty-state>
}
